<template>
	<div class="boxs">
		<div class="dashboard_box">
			<div class="flex_box">
				<div class="flex_box2">
					<!-- 所接订单统计 --- 部门负责人 -->
					<div class="all_order_census" v-if="loadDashboard['所接订单统计'].showState">
						<div class="census_item all_order">
							<div class="title_box">
								<div class="title_left w100">所有订单统计</div>
								<div class="title_right">
									<div
										:class="['timer_item', all_order_active == 1 ? 'active' : '']"
										@click="allOrderActive(1)"
									>
										今日
									</div>
									<div
										:class="['timer_item', all_order_active == 2 ? 'active' : '']"
										@click="allOrderActive(2)"
									>
										本月
									</div>
									<div
										:class="['timer_item', all_order_active == 3 ? 'active' : '']"
										@click="allOrderActive(3)"
									>
										全年
									</div>
									<div class="data_picker">
										<el-date-picker
											:disabled="all_order_active == 1"
											:picker-options="pickerOptions"
											:editable="false"
											size="mini"
											v-model="value1"
											type="daterange"
											range-separator="-"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											@change="dateChange1"
										>
										</el-date-picker>
									</div>
								</div>
							</div>
							<div class="content_box" style="height: 270px">
								<div class="content_item" v-for="(item, index) in all_order_data" :key="index">
									<div class="order_item">
										<div class="all_item" @click="allOrderClick(item.text)">
											<div class="item_left">
												<img :src="item.url" />
											</div>
											<div class="item_right">
												<div class="top">{{ item.text }}</div>
												<div class="bottom">{{ item.value }}个</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 区域订单统计 -->
					<div class="region_order_census min-w430" v-if="loadDashboard['区域订单统计'].showState">
						<div class="census_item region_order">
							<div class="title_box">
								<div class="title_left w70">区域订单统计</div>
								<div class="title_right">
									<div class="data_picker">
										<el-date-picker
											:picker-options="pickerOptions1"
											size="mini"
											v-model="value2"
											type="daterange"
											range-separator="-"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											@change="dateChange2"
										>
										</el-date-picker>
									</div>
								</div>
							</div>
							<div class="content_box flex" style="height: 270px">
								<div class="canvas" style="width: 400px; min-height: 224px">
									<div class="census_pie" id="census_pie" style="width: 400px; height: 224px"></div>
								</div>
							</div>
						</div>
					</div>

					<!-- 订单时效 --- 设计师 -->
					<div
						class="order_aging_s min-w380"
						v-if="loadDashboard['订单时效'].showState && !showChenge('订单来源')"
					>
						<div class="census_item all_order">
							<div class="title_box">
								<div class="title_left w70">订单时效</div>
							</div>
							<div class="content_box" style="height: 270px">
								<div class="content_item" v-for="(item, index) in orderAging_data" :key="index">
									<div class="order_item">
										<div class="item_left">
											<img :src="item.url" alt="" />
										</div>
										<div class="item_right">
											<div class="top">{{ item.text }}</div>
											<div class="bottom">{{ item.value }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="flex_box3">
					<div class="flex_box3_box">
						<!-- 订单统计 -->
						<div class="order_census min-w380" v-if="loadDashboard['订单统计'].showState">
							<div class="census_item region_order">
								<div class="title_box">
									<div class="title_left w70">订单统计</div>
									<div class="title_right">
										<div class="data_picker">
											<el-date-picker
												size="mini"
												:picker-options="pickerOptions1"
												v-model="value3"
												type="daterange"
												range-separator="-"
												start-placeholder="开始日期"
												end-placeholder="结束日期"
												@change="dateChange3"
											>
											</el-date-picker>
										</div>
									</div>
								</div>
								<div class="content_box flex">
									<div class="canvas" style="width: 365px; min-height: 224px">
										<div
											class="order_census"
											id="order_census"
											style="width: 365px; min-height: 224px; height: 370px"
										></div>
									</div>
								</div>
							</div>
						</div>

						<!-- 订单来源 --- 部门负责人 h-370 -->
						<div
							class="order_source min-w380"
							v-if="showChenge('订单来源') && showChenge('员工当月排行榜')"
						>
							<div class="census_item source_box">
								<div class="title_box">
									<div class="title_left w70">订单来源</div>
									<div class="title_right">
										<div class="data_picker">
											<el-date-picker
												size="mini"
												:picker-options="pickerOptions1"
												v-model="value4"
												type="daterange"
												range-separator="-"
												start-placeholder="开始日期"
												end-placeholder="结束日期"
												@change="dateChange4"
											>
											</el-date-picker>
										</div>
									</div>
								</div>
								<div class="content_box flex">
									<div class="canvas" style="width: 365px; min-height: 224px">
										<div
											class="order_source"
											id="order_source"
											style="width: 365px; height: 370px"
										></div>
									</div>
								</div>
							</div>
						</div>

						<!-- 订单来源 --- 区域负责人 h-224 -->
						<div
							class="order_source min-w380"
							v-if="showChenge('订单来源') && !showChenge('员工当月排行榜')"
						>
							<div class="census_item source_box">
								<div class="title_box">
									<div class="title_left w70">订单来源</div>
									<div class="title_right">
										<div class="data_picker">
											<el-date-picker
												size="mini"
												:picker-options="pickerOptions1"
												v-model="value4"
												type="daterange"
												range-separator="-"
												start-placeholder="开始日期"
												end-placeholder="结束日期"
												@change="dateChange4"
											>
											</el-date-picker>
										</div>
									</div>
								</div>
								<div class="content_box flex">
									<div class="canvas" style="width: 365px; min-height: 224px">
										<div
											class="order_source"
											id="order_source1"
											style="width: 365px; height: 224px"
										></div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 员工当月排行榜 -->
					<div class="staff ranking_list min-w430" v-if="loadDashboard['员工当月排行榜'].showState">
						<div class="census_item personnel_list">
							<div class="title_box">
								<div class="title_left w115">员工当月排行榜</div>
								<div class="title_right">
									<div class="data_picker">
										<el-date-picker
											size="mini"
											:picker-options="pickerOptions1"
											v-model="value5"
											type="daterange"
											range-separator="-"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											@change="dateChange5"
										>
										</el-date-picker>
									</div>
								</div>
							</div>
							<div class="content_box" style="height: 418px" v-if="staffList_data.length">
								<div class="box_title">
									<div class="title_item item1">排名</div>
									<div class="title_item item2">姓名</div>
									<div class="title_item item3">地区</div>
									<div class="title_item item2 item_order">订单数量</div>
								</div>
								<div class="box_item" v-for="(item, index) in staffList_data" :key="index">
									<div class="item_ranking item1">
										<div class="bj">{{ index + 1 }}</div>
									</div>
									<div class="item_name item2">{{ item.name }}</div>
									<div class="item_region item3">{{ item.area_name }}</div>
									<div class="item_order item2">{{ item.value }}</div>
								</div>
							</div>
							<div class="content_box" style="height: 418px" v-else>
								<div class="showState">暂无数据</div>
							</div>
						</div>
					</div>

					<!-- 订单时效 --- 区域负责人 h-224 -->
					<div
						class="order_aging_s min-w380 order_aging_s_flex"
						v-if="
							loadDashboard['订单时效'].showState &&
							showChenge('订单来源') &&
							!showChenge('员工当月排行榜')
						"
					>
						<div class="census_item all_order">
							<div class="title_box">
								<div class="title_left w70">订单时效</div>
							</div>
							<div class="content_box" style="height: 278px">
								<div class="content_item" v-for="(item, index) in orderAging_data" :key="index">
									<div class="order_item">
										<div class="item_left">
											<img :src="item.url" alt="" />
										</div>
										<div class="item_right">
											<div class="top">{{ item.text }}</div>
											<div class="bottom">{{ item.value }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="flex_box4">
					<!-- 订单时效 --- 区域负责人 h-224 -->
					<div
						class="order_aging_s min-w380"
						v-if="
							loadDashboard['订单时效'].showState &&
							showChenge('订单来源') &&
							showChenge('员工当月排行榜')
						"
					>
						<div class="census_item all_order">
							<div class="title_box">
								<div class="title_left w70">订单时效</div>
							</div>
							<div class="content_box" style="height: 270px">
								<div class="content_item" v-for="(item, index) in orderAging_data" :key="index">
									<div class="order_item">
										<div class="item_left">
											<img :src="item.url" />
										</div>
										<div class="item_right">
											<div class="top">{{ item.text }}</div>
											<div class="bottom">{{ item.value }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="flex_box4_box">
						<!-- 平均订单时效 -->
						<div class="order_aging average" v-if="loadDashboard['平均订单时效'].showState">
							<div class="census_item personnel_list">
								<div class="title_box">
									<div class="title_left">平均订单时效</div>
									<div class="title_right"></div>
								</div>
								<div class="content_box">
									<div class="box_title">
										<div class="title_item item1">排名</div>
										<div class="title_item item2">姓名</div>
										<div class="title_item item3">地区</div>
										<div class="title_item item2 item_order">时效</div>
									</div>
									<div
										class="box_item"
										v-for="(item, index) in orderAvgTimeliness_data"
										:key="index"
									>
										<div class="item_ranking item1">
											<div class="bj">{{ index + 1 }}</div>
										</div>
										<div class="item_name item2">{{ item.real_name }}</div>
										<div class="item_region item3">{{ item.area_name }}</div>
										<div class="item_order item2">{{ item.time }}</div>
									</div>
								</div>
							</div>
						</div>

						<!-- 最快处理时效 -->
						<div class="order_aging fastest" v-if="loadDashboard['最快处理时效'].showState">
							<div class="census_item personnel_list">
								<div class="title_box">
									<div class="title_left">最快处理时效</div>
									<div class="title_right"></div>
								</div>
								<div class="content_box">
									<div class="box_title">
										<div class="title_item item1">排名</div>
										<div class="title_item item2">姓名</div>
										<div class="title_item item3">地区</div>
										<div class="title_item item2 item_order">时效</div>
									</div>
									<div
										class="box_item"
										v-for="(item, index) in orderFastestTimeliness_data"
										:key="index"
									>
										<div class="item_ranking item1">
											<div class="bj">{{ index + 1 }}</div>
										</div>
										<div class="item_name item2">{{ item.real_name }}</div>
										<div class="item_region item3">{{ item.area_name }}</div>
										<div class="item_order item2">{{ item.time }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 最慢处理时效 -->
					<div class="order_aging slowest" v-if="loadDashboard['最慢处理时效'].showState">
						<div class="census_item personnel_list">
							<div class="title_box">
								<div class="title_left">最慢处理时效</div>
								<div class="title_right"></div>
							</div>
							<div class="content_box">
								<div class="box_title">
									<div class="title_item item1">排名</div>
									<div class="title_item item2">姓名</div>
									<div class="title_item item3">地区</div>
									<div class="title_item item2 item_order">时效</div>
								</div>
								<div
									class="box_item"
									v-for="(item, index) in orderSlowestTimeliness_data"
									:key="index"
								>
									<div class="item_ranking item1">
										<div class="bj">{{ index + 1 }}</div>
									</div>
									<div class="item_name item2">{{ item.real_name }}</div>
									<div class="item_region item3">{{ item.area_name }}</div>
									<div class="item_order item2">{{ item.time }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		$panelOrderCount,
		$panelAreaOrder,
		$panelOrderChart,
		$orderAging,
		$orderSource,
		$staffList,
		$orderAvgTimeliness,
		$orderFastestTimeliness,
		$orderSlowestTimeliness,
	} from '@/api';
	export default {
		data() {
			return {
				adminId: 0,
				// all_order_imgs: [
				//   {text: '待接订单', url: require('../assets/icon/daijiedan.png')},
				//   {text: '待报价', url: require('../assets/icon/daibaojia.png')},
				//   {text: '待支付', url: require('../assets/icon/daizhifu.png')},
				//   {text: '设计中', url: require('../assets/icon/design.png')},
				//   {text: '待验收', url: require('../assets/icon/daiyanshou.png')},
				// ],
				all_order_icons: {
					// 所有订单统计icon
					待接订单: require('../assets/icon/daijiedan.png'),
					待报价: require('../assets/icon/daibaojia.png'),
					待支付: require('../assets/icon/daizhifu.png'),
					设计中: require('../assets/icon/design.png'),
					待验收: require('../assets/icon/daiyanshou.png'),
				},
				order_aginge_icons: {
					// 订单失效icon
					平均订单时效: require('../assets/icon/daizhifu2.png'),
					最快处理时效: require('../assets/icon/shejizhong.png'),
					最慢处理时效: require('../assets/icon/daiyanshou2.png'),
				},

				all_order_active: 0,
				value1: [], // 所有订单日历
				value2: [], // 区域订单统计
				value3: [], // 订单统计
				value4: [], // 订单来源
				value5: [], // 员工当月排行榜

				// 仪表盘 权限
				permissions: {},
				permissionsChildren: [],
				permissionsChildrenNameList: {}, // 权限 name

				deteTab: {
					day: {
						text: '今日',
					},
					month: {
						text: '本月',
						rule: (time) => {
							let { firstDay, new_date } = this.getDateTime('month');
							return time.getTime() > new_date.getTime() || time.getTime() < firstDay.getTime();
						},
					},
					year: {
						text: '全年',
						rule: (time) => {
							let { firstDay, new_date } = this.getDateTime('year');
							return time.getTime() > new_date.getTime() || time.getTime() < firstDay.getTime();
						},
					},
				},
				pickerOptions: {
					// 日期时间限制
					disabledDate: (time) => {
						//true 不能选择  false 能选择
						if (this.all_order_active == 0) {
							return this.pickerOptions1.disabledDate(time);
						} else if (this.all_order_active == 2) {
							return this.deteTab.month.rule(time);
						} else if (this.all_order_active == 3) {
							return this.deteTab.year.rule(time) || time.getTime() > Date.now();
						}
					},
				},
				pickerOptions1: {
					// 日期时间限制1
					disabledDate: (time) => {
						//true 不能选择  false 能选择
						return time.getTime() > Date.now();
					},
				},

				all_order_data: [], // 所有订单数据
				region_order_census: {}, // 区域订单
				orderAging_data: [], // 订单时效
				staffList_data: [], // 员工当月排行榜
				orderAvgTimeliness_data: [], // 平均订单时效
				orderFastestTimeliness_data: [], // 最快处理时效
				orderSlowestTimeliness_data: [], // 最慢处理时效
				// 所接订单统计', '订单来源', '区域订单统计', '订单统计', '员工当月排行榜', '平均订单时效', '最快处理时效', '最慢处理时效',
				loadDashboard: {
					所接订单统计: {
						showState: false,
						trigger: () => {
							this.panelOrderCount(); // 所有订单数据
						},
					},
					区域订单统计: {
						showState: false,
						trigger: () => {
							this.panelAreaOrder(); // 区域订单
						},
					},
					订单统计: {
						showState: false,
						trigger: () => {
							this.panelOrderChart(); // 订单统计
						},
					},
					订单来源: {
						showState: false,
						trigger: () => {
							this.getOrderSource(); // 订单来源
						},
					},
					员工当月排行榜: {
						showState: false,
						trigger: () => {
							this.staffList(); // 员工当月排行榜
						},
					},
					订单时效: {
						showState: false,
						trigger: () => {
							this.orderAging(); // 订单时效
						},
					},
					平均订单时效: {
						showState: false,
						trigger: () => {
							this.orderAvgTimeliness(); // 平均订单时效
						},
					},
					最快处理时效: {
						showState: false,
						trigger: () => {
							this.orderFastestTimeliness(); // 最快处理时效
						},
					},
					最慢处理时效: {
						showState: false,
						trigger: () => {
							this.orderSlowestTimeliness(); // 最慢处理时效
						},
					},
				},

				stateManage: {
					// 所有订单统计 状态管理
					全部: '0',
					待分配: '4',
					待接订单: '5',
					待报价: '6',
					待支付: '7',
					设计中: '8',
					待审核: '9',
					待验收: '18',
					已验收: '20',
					待修改: '10',
					已完成: '15',
					已取消: '12',
				},

				sjs_id: 2,
				qy_id: 3,
				bm_id: 5,
				userInfo: {},
				user_code_id: 0,
			};
		},
		created() {
			// this.getUserInfo();
			this.getTagPermissions();

			let { firstDay, new_date } = this.getDateTime('month');
			this.value2 = [firstDay, new Date().getTime()];
			this.value3 = [firstDay, new Date().getTime()];
			this.value4 = [firstDay, new Date().getTime()];
			this.value5 = [firstDay, new Date().getTime()];
		},
		mounted() {
			// this.panelOrderCount(); // 所有订单数据
			// this.panelAreaOrder(); // 区域订单
			// this.panelOrderChart(); // 订单统计
			// this.getOrderSource(); // 订单来源
			// this.orderAging(); // 订单时效
			// this.staffList(); // 员工当月排行榜
			// this.orderAvgTimeliness(); // 平均订单时效
			// this.orderFastestTimeliness(); // 最快处理时效
			// this.orderSlowestTimeliness(); // 最慢处理时效

			this.permissions.children
				.map((item) => {
					return item.name;
				})
				.forEach((item) => {
					if (this.loadDashboard[item]) {
						this.loadDashboard[item].showState = true;
						this.loadDashboard[item].trigger();
					}
				});
			// console.log(this.loadDashboard);

			// echarts 图像
			// this.censusPie();
			// this.orderCensus();
			// this.orderSource();
		},
		methods: {
			getUserInfo() {
				if (!(JSON.stringify(this.$store.state.userInfo) == '{}')) {
					this.userInfo = this.$store.state.userInfo;
					let user_code_id = this.$store.state.userInfo.user_code;
					// console.log("用户信息", user_code_id, this.userInfo);
				}
			},
			// 切换时间导航
			allOrderActive(num) {
				this.value1 = [];

				if (num == this.all_order_active) {
					this.all_order_active = 0;
					this.panelOrderCount(); // 所有订单数据
					return;
				}
				// 1-今日 2-本月 3-全年
				this.all_order_active = num;

				if (num == 1) {
					this.panelOrderCount(1); // 获取今日 所有订单数据
				} else if (num == 2) {
					this.panelOrderCount(2); // 获取本月 所有订单数据
					let { firstDay } = this.getDateTime('month');
					this.value1 = [firstDay, new Date()];
				} else if (num == 3) {
					this.panelOrderCount(3); // 获取全年 所有订单数据
					let { firstDay } = this.getDateTime('year');
					this.value1 = [firstDay, new Date()];
				}
			},

			// 获取 所接订单统计
			panelOrderCount(time_type = 0, time_range) {
				let params = {
					time_type,
					time_range,
				};
				$panelOrderCount(params)
					.then((res) => {
						// console.log('所有订单统计', res);

						res.data.map((item) => {
							item.url = this.all_order_icons[item.text];
						});
						this.all_order_data = res.data;
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 获取 区域订单统计
			panelAreaOrder(time_range) {
				time_range = time_range ? time_range : this.dateTimeArr(this.value2);
				let params = {
					time_range,
				};

				$panelAreaOrder(params)
					.then((res) => {
						// console.log('区域订单统计', res);
						// this.region_order_census = res.data;
						this.censusPie(res.data);
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 获取 订单统计
			panelOrderChart(time_range) {
				time_range = time_range ? time_range : this.dateTimeArr(this.value3);
				let params = {
					time_range,
				};

				$panelOrderChart(params)
					.then((res) => {
						// console.log('订单统计', res);
						// this.region_order_census = res.data;
						this.orderCensus(res.data);
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 获取 订单时效
			orderAging() {
				$orderAging()
					.then((res) => {
						// console.log('订单时效', res);
						this.orderAging_data = res.data;
						this.orderAging_data.map((item) => {
							item.url = this.order_aginge_icons[item.text];
						});
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 获取 订单来源
			getOrderSource(time_range) {
				time_range = time_range ? time_range : this.dateTimeArr(this.value4);
				let params = {
					time_range,
				};
				// console.log(params, '订单来源');
				$orderSource(params)
					.then((res) => {
						// console.log('订单来源', res);
						this.orderSource(res.data);
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 获取 员工当月排行榜
			staffList(time_range) {
				time_range = time_range ? time_range : this.dateTimeArr(this.value5);
				let params = {
					time_range,
				};
				$staffList(params)
					.then((res) => {
						// console.log('员工当月排行榜', res);
						this.staffList_data = res.data;
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 获取 平均订单时效
			orderAvgTimeliness() {
				$orderAvgTimeliness()
					.then((res) => {
						// console.log('平均订单时效', res);
						this.orderAvgTimeliness_data = res.data;
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 获取 最快处理时效
			orderFastestTimeliness() {
				$orderFastestTimeliness()
					.then((res) => {
						// console.log('最快处理时效', res);
						this.orderFastestTimeliness_data = res.data;
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 获取 最慢处理时效
			orderSlowestTimeliness() {
				$orderSlowestTimeliness()
					.then((res) => {
						// console.log('最慢处理时效', res);
						this.orderSlowestTimeliness_data = res.data;
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 选择日期1   所接订单统计
			dateChange1(e) {
				// e = e?e:'';
				// console.log("所接订单统计", e);
				let dateTime = this.dateTimeArr(e);
				this.panelOrderCount(0, dateTime);
			},
			// 选择日期2   区域订单统计
			dateChange2(e) {
				// e = e?e:'';
				// console.log("区域订单统计", e);
				let dateTime = this.dateTimeArr(e);
				this.panelAreaOrder(dateTime);
			},
			// 选择日期3   订单统计
			dateChange3(e) {
				// e = e?e:'';
				// console.log("订单统计", e);
				let dateTime = this.dateTimeArr(e);
				this.panelOrderChart(dateTime);
			},
			// 选择日期4   订单来源
			dateChange4(e) {
				// e = e?e:'';
				// console.log("订单来源", e);
				let dateTime = this.dateTimeArr(e);
				this.getOrderSource(dateTime);
			},
			// 选择日期5   员工当月排行榜
			dateChange5(e) {
				// e = e?e:'';
				// console.log("员工当月排行榜", e);
				let dateTime = this.dateTimeArr(e);
				this.staffList(dateTime);
			},

			// 点击事件
			// 所有订单统计
			allOrderClick(str) {
				let type = this.stateManage[str];
				this.$router.push({
					path: '/ordermanage',
					query: {
						type,
					},
				});
			},

			///////-------------------------

			// 获取权限
			getTagPermissions() {
				// 获取 用户展示内容权限
				this.$data.permissions = this.$store.state.personalCenterPermissions.find(function check(
					val
				) {
					return val.name === '仪表盘';
				});
				// console.log('权限--', this.permissions);
				this.permissionsChildren = this.permissions.children;
				this.permissionsChildrenNameList = this.permissionsChildren.map((item) => {
					return item.name;
				});
				// console.log('用户展示内容', this.permissionsChildrenNameList);
			},

			// showChenge
			showChenge(str) {
				let showState = false;
				this.permissionsChildrenNameList.filter((item) => {
					if (item == str) return (showState = true);
				});
				// console.log('showChenge', showState);
				return showState;
			},

			// census_pie 区域订单统计 饼图
			censusPie(params) {
				let total = params.total || '0';
				let data = params.list.map((item) => {
					return { name: item.text + ' | ' + item.value, value: item.value };
				});

				let dom = document.getElementById('census_pie');
				if (!dom) return;
				let census_pie = this.$echarts.init(dom);
				census_pie.setOption({
					title: [
						{
							// 第一个圆环标题
							text: '订单总计', // 主标题
							textStyle: {
								// 主标题样式
								fontSize: 14,
								fontWeight: 'bold',
								color: 'rgba(0, 0, 0, 0.45)',
								fontFamily: 'PingFang SC',
							},
							left: '24%', // 定位到适合的位置
							top: '37%', // 定位到适合的位置
							subtext: total, // 副标题
							subtextStyle: {
								// 副标题样式
								fontSize: 30,
								color: 'rgba(0, 0, 0, 0.85)',
								fontWeight: 'bold',
								fontFamily: 'PingFang SC',
							},
							textAlign: 'center', // 主、副标题水平居中显示
						},
					],
					tooltip: {
						// 提示框组件
						trigger: 'item',
					},
					legend: {
						// 图例组件
						top: 'center',
						right: '5%',
						orient: 'vertical',
					},
					label: {
						show: true,
						position: 'center',
					},
					series: [
						{
							name: '区域订单统计',
							type: 'pie',
							center: ['25%', '50%'],
							radius: ['50%', '70%'],
							avoidLabelOverlap: false,
							itemStyle: {
								borderColor: '#fff',
								borderWidth: 4,
							},
							label: {
								show: false,
								position: 'center',
							},
							emphasis: {
								// label: {
								//   show: true,
								//   fontSize: '14',
								//   fontWeight: 'bold'
								// }
							},
							labelLine: {
								show: false,
							},
							data,
							// color:['#13C2C2','#1890FF', '#FACC14', '#e60000', '#8543E0'],
							// data: [
							//   { value: 233, name: '东区订单数量 | 233' },
							//   { value: 200, name: '南区订单数量 | 200' },
							//   { value: 180, name: '西区订单数量 | 180' },
							//   { value: 160, name: '北区订单数量 | 160' },
							//   { value: 150, name: '中区订单数量 | 150' }
							// ]
						},
					],
				});
			},

			// order_census 订单统计 柱状图
			orderCensus(params) {
				let nameLength = false;
				let name = params.map((item) => {
					if (item.name.length > 4) {
						nameLength = true;
					}
					return item.name;
				});
				let value = params.map((item) => {
					return item.value;
				});

				// 空状态
				name = name.length ? name : [' '];
				value = value.length ? value : [0];

				let dom = document.getElementById('order_census');
				if (!dom) return;
				let orderCensus = this.$echarts.init(dom);
				orderCensus.setOption({
					title: {
						text: '订单数',
						textStyle: {
							fontSize: 14,
							fontWidth: 400,
							color: '#999999',
						},

						// show: value.length === 0, // 判断有没有数据，没有则show为true
						// textStyle: {
						//   color: '#ccc',
						//   fontSize: 18
						// },
						// text: "暂无数据",
						// left: "center",
						// top: "center"
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow',
						},
					},
					grid: {
						left: '1%',
						top: '40px',
						right: '0%',
						bottom: '0%',
						containLabel: true,
					},
					xAxis: [
						{
							type: 'category',
							// data: ['韩梅梅', '范雅慧', '黄鑫', '张三丰', '刘明明'],
							data: name,
							axisTick: {
								alignWithLabel: true,
							},
							axisLabel: {
								interval: 0, //横轴信息全部显示，必须设置
								rotate: nameLength ? -20 : 0, //-30度角倾斜显示，根据页面布局实际可以自行调整
							},
						},
					],
					yAxis: [
						{
							type: 'value',
						},
					],
					series: [
						{
							name: '订单数',
							type: 'bar',
							barWidth: '24', // 柱状图宽度
							itemStyle: {
								color: '#e60000',
							},
							// data: [10, 52, 200, 334, 1090]
							data: value,
						},
					],
				});
			},

			// order_source 订单来源 饼图
			orderSource(params) {
				let arr = [];
				let total = params.total || '0';
				for (const key in params) {
					if (key != 'total') arr.push(params[key]);
				}
				let data = arr.map((item) => {
					return { value: item.value, name: item.text + ' | ' + item.value };
				});

				let dom = document.getElementById('order_source'); // 部门负责人 h-370
				let dom1 = document.getElementById('order_source1'); // 区域负责人 h-224
				let left, top, radius;
				if (dom) {
					left = '24%';
					top = '41%';
					radius = ['30%', '43%'];
				} else {
					left = '25%';
					top = '35%';
					radius = ['50%', '70%'];
				}

				// if(!dom) return
				let order_source = this.$echarts.init(dom || dom1);
				order_source.setOption({
					title: [
						{
							// 第一个圆环标题
							text: '订单总计', // 主标题
							textStyle: {
								// 主标题样式
								fontSize: 14,
								fontWeight: 'bold',
								color: 'rgba(0, 0, 0, 0.45)',
								fontFamily: 'PingFang SC',
							},
							left, // 定位到适合的位置
							top, // 定位到适合的位置
							subtext: total, // 副标题
							subtextStyle: {
								// 副标题样式
								fontSize: 30,
								color: 'rgba(0, 0, 0, 0.85)',
								fontWeight: 'bold',
								fontFamily: 'PingFang SC',
							},
							textAlign: 'center', // 主、副标题水平居中显示
						},
					],
					tooltip: {
						// 提示框组件
						trigger: 'item',
					},
					legend: {
						// 图例组件
						top: 'center',
						right: '0%',
						orient: 'vertical',
					},

					series: [
						{
							name: '区域订单统计',
							type: 'pie',
							center: ['25%', '50%'],
							radius,
							avoidLabelOverlap: false,
							itemStyle: {
								borderColor: '#fff',
								borderWidth: 4,
							},
							label: {
								show: false,
								position: 'center',
							},
							labelLine: {
								show: false,
							},
							// data: [
							//   { value: 233, name: '东区订单数量1 | 233' },
							//   { value: 200, name: '南区订单数量2 | 200' },
							//   { value: 233, name: '东区订单数量3 | 233' },
							//   { value: 200, name: '南区订单数量4 | 200' },
							// ],
							data,
							color: [
								'#e60000',
								'#3AA1FF',
								'#EE6363',
								'#FFD700',
								'#FF69B4',
								'#CD661D',
								'#DA70D6',
								'#912CEE',
								'#1E90FF',
								'#32CD32',
								'#8470FF',
								'#00C5CD',
								'#FFDAB9',
								'#698B69',
								'#8470FF',
							],
						},
					],
				});
			},

			// 获取时间 第一天 和 最后一天
			/**
			 * params {string} 'month'  返回本月 第一天和最后一天
			 *        {string} 'year'   返回今年 第一天和最后一天
			 *
			 * return { firstDay, new_date }
			 */
			getDateTime(str) {
				let date = new Date();
				let firstDay, new_date;
				let new_year = date.getFullYear();
				let new_month = date.getMonth();
				if (str == 'month') {
					firstDay = new Date(new_year, new_month, 1); //// 本月第一天
					new_date = new Date(new_year, new_month + 1, 0); //// 本月最后一天
				} else if (str == 'year') {
					firstDay = new Date(new_year, 0, 1); //// 本年第一天
					new_date = new Date(new_year + 1, 0, 0); //// 本年最后一天
				}

				return { firstDay, new_date };
			},
			// // 获取全年第一天 和 最后一天
			// getYearFate() {
			//   let date = new Date();
			//   let firstDay = new Date(date.getFullYear(), 0, 1); //// 本年第一天
			//   let new_year = date.getFullYear();
			//   let new_date = new Date(new_year+1, 0, 0); //// 本年最后一天
			//   return {firstDay, new_date}
			// },

			// 时间转换
			timeConversion(params) {
				// 时间转换
				let y = new Date(params).getFullYear(); // 年
				let m = new Date(params).getMonth() + 1; // 月
				let d = new Date(params).getDate(); // 日

				m = m < 10 ? '0' + m : m;
				d = d < 10 ? '0' + d : d;

				// console.log(`${y}-${m}-${d}`);
				return `${y}-${m}-${d}`;
			},
			// 日期时间数组 处理
			dateTimeArr(params) {
				if (params) {
					// 判断是否为空
					let arr = [];
					for (let i = 0; i < params.length; i++) {
						arr.push(this.timeConversion(params[i]));
					}
					return arr.join('~');
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.boxs {
		width: 100%;
		min-height: 100%;
	}
	.dashboard_box {
		min-height: 100%;
		box-sizing: border-box;
		font-size: 16px;
	}

	// 弹性盒子
	.flex_box {
		display: flex;
		// flex-wrap: wrap;
		flex-direction: column;

		.flex_box2 {
			width: 100%;
			padding-top: 24px;
			padding-left: 24px;
			box-sizing: border-box;
			display: flex;
			flex-wrap: wrap;
			& > div {
				margin-right: 24px;
			}
			.all_order_census {
				// 所接订单统计
				flex: 2;
				min-width: 650px;
			}
			.region_order_census {
				//区域订单统计
				flex: 1;
				// max-width: 33%;
			}
			.order_aging_s {
				flex: 1;
			}
		}
		.flex_box3 {
			display: flex;
			flex-wrap: wrap;
			padding-left: 24px;
			box-sizing: border-box;
			& > div {
				margin-right: 24px;
			}
			.flex_box3_box {
				flex: 2;
				display: flex;
			}
			.order_census {
				// 订单统计
				flex: 1;
				margin-right: 24px;
			}
			.order_census {
				// 订单来源
				flex: 1;
			}
			.order_source {
				// 订单来源
				flex: 1;
			}
			.order_aging_s {
				// 订单时效
				flex: 1;
				// max-width: 66%;
			}
			.staff {
				// 员工当月排行榜
				flex: 1;
			}
			.order_aging_s_flex {
				// 订单时效
				flex: 4;
			}
		}
		.flex_box4 {
			display: flex;
			flex-wrap: wrap;
			padding-left: 24px;
			box-sizing: border-box;
			.order_aging {
				// 时效
				flex: 1;
				margin-right: 24px;
				min-width: 330px;
				max-width: calc(50% - 24px);
			}
			.flex_box4_box {
				flex: 2;
				display: flex;
				margin-right: 24px;
			}
			.order_aging_s {
				// 订单时效
				flex: 1;
				min-width: 380px;
			}
			.average {
				// 平均订单
				max-width: 50%;
			}
			.fastest {
				// 最快处理
				margin-right: 0 !important;
				max-width: 50%;
			}
			.slowest {
				// 最慢处理
				// min-width: 430px;
			}
		}

		& > div > .min-w430 {
			min-width: 430px;
		}
		& > div > .min-w415 {
			min-width: 415px;
		}
		& > div > .min-w380 {
			min-width: 380px;
		}

		// -----------------------------

		.flex {
			display: flex;
			justify-content: center;
		}
		.census_item {
			min-height: 36px;
			margin-bottom: 24px;
			border-radius: 4px;
			background: #ffffff;
		}
		.title_box {
			height: 48px;
			padding: 10px 32px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			border-bottom: 1px solid #e8e8e8;
			.title_left {
				// min-width: 100px;
				color: #333333;
				font-weight: 600;
			}
			.title_right {
				display: flex;
				align-items: center;
				color: #999999;
				font-size: 14px;
				.timer_item {
					margin-right: 24px;
					cursor: pointer;
				}
			}
			.w100 {
				min-width: 100px;
			}
			.w115 {
				min-width: 115px;
			}
			.w70 {
				min-width: 70px;
			}
			.active {
				color: #e60000;
			}
		}

		.order_aging_s {
			// 订单来源
			.content_box {
				.content_item {
					min-width: 145px;
					.order_item {
						cursor: auto;
					}
				}
			}
		}
	}

	.content_box {
		position: relative;
		display: flex;
		flex-wrap: wrap;
		// align-items: center;
		// align-items: flex-start;
		align-content: flex-start;
		width: 100%;
		min-height: 254px;
		padding: 27px 32px;
		.content_item {
			width: 33%;
			min-width: 120px;
			.order_item {
				display: flex;
				align-items: center;
				.all_item {
					width: 120px;
					display: flex;
					align-items: center;
					cursor: pointer;
				}
				img {
					width: 48px;
					height: 48px;
				}
				.item_right {
					margin-left: 12px;
					.top {
						color: #999999;
						font-size: 12px;
						margin-right: 12px;
					}
					.bottom {
						color: #333333;
						font-size: 16px;
					}
				}
			}
		}
		.box_title {
			position: absolute;
			// height: 19px;
			top: 0;
			left: 50%;
			transform: translateX(-50%);
			width: 100%;
			padding: 12px 34px 0 34px;
			color: #999999;
			font-size: 14px;
			display: flex;
		}
		.box_item {
			width: 100%;
			display: flex;
			margin-top: 20px;
			font-size: 14px;
			color: #333333;
			&:nth-child(-n + 4) {
				.bj {
					color: #ffffff;
					background: #314659;
				}
			}
		}
		.item_order {
			text-align: center;
			font-weight: bold;
		}

		.item1 {
			flex: 1;
			font-size: 14px;
			min-width: 30px;
			margin-right: 20px;
			.bj {
				display: flex;
				align-items: center;
				justify-content: center;
				// margin: 0 auto;
				margin-left: 5px;
				width: 20px;
				height: 20px;
				text-align: center;
				background: #f0f2f5;
				border-radius: 50%;
				color: rgba(0, 0, 0, 0.65);
			}
		}
		.item2 {
			flex: 2;
			min-width: 125px;
		}
		.item3 {
			flex: 3;
			min-width: 56px;
		}

		.showState {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			height: 100%;
			text-align: center;
			font-size: 16px;
			color: #ccc;
		}
	}

	.all_order {
		// 所有订单统计
		.content_box {
			padding: 24px 32px 24px 80px;
			align-content: normal;
			align-items: center;
		}
	}

	.el-date-editor--daterange.el-input__inner {
		width: 256px;
	}
	.el-row {
		margin-bottom: 20px;
		&:last-child {
			margin-bottom: 0;
		}
	}
	.el-col {
		border-radius: 4px;
	}

	.line-24 {
		width: 24px;
		height: 100%;
		background: transparent;
	}
	.mar-rigth0 {
		margin-right: 0px !important;
	}

	::v-deep {
		// 输入框 边框颜色
		.el-range-editor.is-active {
			border-color: $theme-color;
			&:hover {
				border-color: $theme-color;
			}
		}
	}
</style>
